export default __webpack_public_path__ + "static/media/whychoose_pattern.0ed7eafa.svg";